import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';

function isInListInsideTable(view: EditorView): boolean {
  const { $from } = view.state.selection;
  let { depth } = $from;
  let inTable = false;
  let inList = false;

  for (; depth > 0; depth -= 1) {
    const nodeName = $from.node(depth).type.name;
    if (nodeName === 'tableCell' || nodeName === 'tableHeader') inTable = true;
    if (nodeName === 'listItem') inList = true;
    if (inTable && inList) return true;
  }

  return false;
}

export const TableListIndent = Extension.create({
  name: 'tableListIndent',

  addProseMirrorPlugins() {
    const { editor } = this;

    return [
      new Plugin({
        key: new PluginKey('tableListIndent'),
        props: {
          handleDOMEvents: {
            keydown(view: EditorView, event: KeyboardEvent) {
              if (event.key !== 'Tab') return false;
              if (!isInListInsideTable(view)) return false;

              event.preventDefault();

              if (event.shiftKey) {
                editor.commands.liftListItem('listItem');
              } else {
                editor.commands.sinkListItem('listItem');
              }
              return true;
            },
          },
        },
      }),
    ];
  },
});
